import React, {
  useContext,
  useState,
  useRef,
  useImperativeHandle,
  forwardRef,
  useEffect,
} from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Button,
  mergeClasses,
} from '@fluentui/react-components';
import { HelpLink } from '@bingads-webui-react/help-link';
import { usePoliticalAdsDeclarationStyles } from './styles';

export interface PoliticalAdsDialogHandle {
  open: (el: HTMLElement) => void;
}

export interface PoliticalAdsDialogProps {
  dialogContentText: string;
}

export const PoliticalAdsDialog = forwardRef<
  PoliticalAdsDialogHandle,
  PoliticalAdsDialogProps
>(({ dialogContentText }, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggeringElement = useRef<HTMLElement | null>(null);
  const i18n = useContext(I18nContext);
  const classes = usePoliticalAdsDeclarationStyles();

  useImperativeHandle(ref, () => ({
    open: (el: HTMLElement) => {
      triggeringElement.current = el;
      setIsOpen(true);
    },
  }));

  const handleCloseDialog = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (!isOpen && triggeringElement.current) {
      setTimeout(() => {
        triggeringElement.current?.focus();
      }, 0);
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen}>
      <DialogSurface className="political-ads-dialog">
        <DialogBody>
          <DialogTitle>
            {i18n.getString(_TL_('Political advertising is not allowed'))}
          </DialogTitle>
          <DialogContent className={mergeClasses(classes.dialogContent, 'political-ads-dialog-content')}>
            <div>
              {dialogContentText}
              &nbsp;
              <HelpLink query="help:app54875">
                {i18n.getString(_TL_('Learn more'))}
              </HelpLink>
            </div>
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={handleCloseDialog}>
              {i18n.getString(_TL_('Close'))}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
});
